/* 商品選択 */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import ProductList from '../../templates/ProductList';
import { handleBrowserBack } from '../../BrowserBack';

const ProductSelect: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);
  return (
    <>
      <ProductList />
    </>
  );
};
if (document.getElementById('product-select-applicant')) {
  ReactDOM.render(<ProductSelect />, document.getElementById('product-select-applicant'));
}
